import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./ApplianceListDiscStyles";
import Disc from "./Disc";

export default class ApplianceListDisc extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let url = "";

    if (!this.props.isSettings && this.props.isAssistedLiving) {
      url = `/parents-home/appliance/${this.props.id}`;
    } else if (this.props.isSettings) {
      if (this.props.isAssistedLiving) {
        url = `/account/infocare/appliance/${this.props.id}`;
      } else {
        url = `/account/homeview/appliance/${this.props.id}`;
      }
    } else {
      url = `/my-home/appliance/${this.props.id}`;
    }

    return (
      <a href={url} className={css(styles.container)}>
        <div className={css(styles.discWrapper)}>
          <Disc {...this.props} />
        </div>
        <div className={css(styles.textContainer)}>
          <span className={css(styles.title)}>{this.props.title}</span>
          {this.props.state === "on" && (
            <span className={css(styles.isOn)}>
              <span className={css(styles.onHightlight)}>On</span> in the past
              hour
            </span>
          )}
        </div>
        <div className={css(styles.arrow)}>&#xf105;</div>
      </a>
    );
  }
}
